export enum configurationFieldState {
  irrelevant,
  selected,
  unselected,
}
